import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/workspace/axios';
import { getPolicySectionsFromResponse } from './queries';
import {
  setPolicyDetailsError,
  setPolicyDetailsLoading,
  setPolicySections,
} from './slice';

const POLICY_DETAILS_ENDPOINT = '/api/v1/policy-details';
const FALLBACK_ERROR_MESSAGE = 'Unable to load policy details.';

const getRouteParam = (key: string) => {
  try {
    const { hash, search } = window.location;
    const hashQueryString = hash.includes('?') ? hash.split('?')[1] : '';
    const hashParams = new URLSearchParams(hashQueryString);
    const searchParams = new URLSearchParams(search || '');
    return hashParams.get(key) || searchParams.get(key) || '';
  } catch {
    return '';
  }
};

const getAuthToken = () => getRouteParam('auth_token');

const getVoCode = () => getRouteParam('vo_code');

export const fetchPolicyDetails = createAsyncThunk(
  'policyDetails/fetchPolicyDetails',
  async (_, { dispatch }) => {
    try {
      dispatch(setPolicyDetailsLoading(true));
      dispatch(setPolicyDetailsError(''));

      const response = await axios.post(
        POLICY_DETAILS_ENDPOINT,
        {
          vo_code: getVoCode(),
        },
        {
          headers: { 'x-vymo-auth-token': getAuthToken() },
        },
      );
      dispatch(
        setPolicySections(getPolicySectionsFromResponse(response?.data?.data)),
      );
    } catch (error: any) {
      dispatch(setPolicySections([]));
      dispatch(setPolicyDetailsError(error?.message || FALLBACK_ERROR_MESSAGE));
    } finally {
      dispatch(setPolicyDetailsLoading(false));
    }
  },
);

const onActivate = ({ dispatch }) => {
  dispatch(fetchPolicyDetails());
};

const onDeactivate = () => {};

export default { onActivate, onDeactivate };
